import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import {PlayerQueryOrder} from "./services/PlayerQueryOrder";
import {PlayerQueryFilterForm} from "./services/PlayerQueryFilterForm";
import {PlayerQueryFilter} from "./services/PlayerQueryFilter";
import {MenuNavigationComponentManager} from "../vue/services/MenuNavigationComponentManager";
import {ColorEnum, IconEnum} from "../vue/enums";

export class GlobalSearchModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [];

  eventSubscribers = [
    GameCreationEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<PlayerQueryOrder>(PlayerQueryOrder).to(PlayerQueryOrder);
    this.app.bind<PlayerQueryFilterForm>(PlayerQueryFilterForm).to(PlayerQueryFilterForm);
    this.app.bind<PlayerQueryFilter>(PlayerQueryFilter).to(PlayerQueryFilter);
  }

  boot() {
    super.boot();

    this.app
      .get(MenuNavigationComponentManager)
      .addItem({color: ColorEnum.Red, icon: IconEnum.PersonSearchOutlined, route: {name: 'global-players.index'}})
  }
}
